import { AppConfig } from '../../../common/model/config';
import { multiplanTheme } from '../themes/multiplan.theme';
import { ORDER_TYPE_DELIVERY } from '../../../common/model/order-types';

export const vilaOlimpiaConfig: AppConfig = {
  appName: 'vila-olimpia',
  appTitle: 'Vila Olímpia',
  appDescription: 'Peça aqui nos restaurantes do Shopping Vila Olímpia.',
  aggregator: 348,
  brand: 450,
  theme: multiplanTheme,
  faviconPath: '/favicons/favicon-multiplan.ico',
  defaultOrderType: ORDER_TYPE_DELIVERY,
  featureFlags: {
    embeddedApplication: false,
    getBrandThemeFromBackend: false,
    shuffleCompanyArray: true,
    gmapsAddress: false,
    showOptionsTabsAggregators: false,
    filterByDeliveryArea: false,
    useLocalAggregatorHeaderImg: false,
    removeLogoFromTheApp: true,
  },
};
